import type { Client } from '../client';

export type PlalistItemContenType =
    | 'live'
    | 'video_importer'
    | 'live_recording';

export type PlaylistLogoPosition =
    | 'top-right'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-left';

export type PlaylistLogo = {
    image: string;
    position: PlaylistLogoPosition;
    width: string;
    margin: string;
};

export type PlaylistItem = {
    content_id: string;
    content_type: PlalistItemContenType;
    content_url: string | null;
    playback_sec: number;
    enable_audio: boolean;
};

export type PlaylistItemContent = {
    id: string;
    type: string; // live or vod
    index: number;
    metadata: Record<string, any>;
    source: {
        src: string;
        type: string;
    };
    playback_sec: number;
    enable_audio: boolean;
};

export type Playlist = {
    name: string;
    description: string;
    resolution: number;
    template_name: string;
    logo?: PlaylistLogo;
    display_safearea: boolean | undefined;
    playlist: PlaylistItem[];
    map_detail?: string;
    audio_url: string;
};

export class PlaylistClass {
    client: Client;
    playlist: Playlist = {
        name: '',
        description: '',
        resolution: 720,
        template_name: '',
        display_safearea: false,
        playlist: [],
        audio_url: '',
    };
    nextItem: number = 0;
    errItem: number = 0;
    callback: any;

    constructor(client: Client) {
        this.client = client;
    }

    async sleep(ms: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async refresh() {
        try {
            const playlist = await this.client.fetchPlaylist();
            if (playlist.playlist.length === 0) {
                console.error(`playlist is empty`);
                return;
            }

            if (playlist.playlist.length === 1) {
                console.log('ping');
            }

            this.playlist = playlist;
            console.log(
                `playlist updated with ${playlist.playlist.length} elements`,
            );

            if (typeof this.callback == 'function') {
                this.callback(playlist);
            }
        } catch (error) {
            console.error(`failed to fetch playlist: ${error}`);
        }

        // Update playlist every 30 seconds
        setTimeout(() => {
            this.refresh();
        }, 30000);
    }

    async getNextContent(): Promise<PlaylistItemContent | null> {
        const length = this.playlist.playlist.length;

        if (length === 0) {
            console.warn(`playlist is empty`);
            await this.sleep(1000);
            return null;
        }

        do {
            if (this.nextItem >= length) {
                this.nextItem = 0;
            }

            const item = this.playlist.playlist[this.nextItem];

            this.nextItem++;

            try {
                const content = await this.client.getContent({
                    content_id: item.content_id,
                    content_type: item.content_type,
                    content_url: item.content_url,
                    index: this.nextItem - 1,
                    playback_sec: item.playback_sec,
                    resolution: this.playlist.resolution,
                    enable_audio: item.enable_audio,
                });

                this.errItem = 0;

                return content;
            } catch (error) {
                this.errItem++;
                console.warn(
                    `content ${item.content_id} (${item.content_type}) could not be loaded: ${error}`,
                );
            }

            await this.sleep(1000);
        } while (true);
    }

    onNewPlaylist(callback: any): void {
        this.callback = callback;
    }

    hasAudio(): boolean {
        return this.playlist.audio_url.length != 0;
    }

    getAudioUrl(): string {
        return this.playlist.audio_url;
    }
}
